"use strict";

function secondsToHms(d) {
    d = Number(d);
    const h = Math.floor(d / 3600);
    const m = Math.floor(d % 3600 / 60);
    const s = Math.floor(d % 3600 % 60);
    return ('0' + h).slice(-2) + ":" + ('0' + m).slice(-2) + ":" + ('0' + s).slice(-2);
}

function parseGATime(gaTime){
    return {
        year: gaTime.slice(0,4),
        month: parseInt(gaTime.slice(4,6), 10) -1,
        day: gaTime.slice(6,8),
        hour: gaTime.slice(8,10),
        minute: gaTime.slice(10,12),
        second: gaTime.slice(12,14),
    };
}

function gaTimeToDateObject(gaTime){
    const gaTimeObj = parseGATime(gaTime);
    return new Date(
        gaTimeObj.year,
        gaTimeObj.month,
        gaTimeObj.day,
        gaTimeObj.hour,
        gaTimeObj.minute,
        gaTimeObj.second,
    );
}

function apiTimestampToDate(ts){
    if(!!ts){
        //
    }
}

function myTimestampToDate(sqlTimestamp){
    if(!!sqlTimestamp){
        let t= sqlTimestamp.split(/[- :Tt.]/);
        t[1]--; // monthIndex needs to be decremented by one
        //return new Date(t[0], t[1], t[2], t[3], t[4], t[5]); // our Date object
        return new Date(Date.UTC(t[0], t[1], t[2], t[3], t[4], t[5])); // our Date object
    }
    return null;
}

function dateToDateTimeLocal(date){
    return date.toISOString().slice(0, -1);
}

function dateToDateInput(date){
    return !!date ? date.getFullYear().toString() + '-' + (date.getMonth() + 1).toString().padStart(2, 0) +
        '-' + date.getDate().toString().padStart(2, 0) : null;
}

function dateToMysqlDateTime(date){
    return (new Date(date.getTime() - timeZoneOffset())).toISOString().slice(0, 19).replace('T', ' ');
}

function timeZoneOffset(){
    return (new Date()).getTimezoneOffset() * 60000;
}

function dateDiffDays(d1, d2=null){
    const date1 = new Date(d1),
          date2 = new Date(d2),
          timeDifference = Math.abs(date2.getTime() - date1.getTime());
    return Math.ceil(timeDifference / (1000 * 3600 * 24));
}

function isZeroTimeStamp(ts=''){
    return /^0000/g.test(ts);
}

function dateDashesToSlashes(d=''){
    if(!!d)
        return d.replace(/-/g, "/");
    return d;
}

export {
    secondsToHms,
    parseGATime,
    gaTimeToDateObject,
    myTimestampToDate,
    apiTimestampToDate,
    dateDiffDays,
    dateToDateTimeLocal,
    dateToDateInput,
    dateToMysqlDateTime,
    dateDashesToSlashes,
    isZeroTimeStamp,
};
